import React, { FC, useEffect } from 'react';
import cx from 'classnames';
import { useActions } from '../../hooks/useActions';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import styles from './styles.module.scss';

export const TodoList: FC = () => {
    const { page, todos, limit } = useTypedSelector((state) => state.todo);
    const { fetchTodo, setTodoPage } = useActions();
    const pages = [1, 2, 3, 4, 5];

    useEffect(() => {
        fetchTodo(page, limit);
    }, [page]);

    return (
        <div className={styles.todoList}>
            todo
            {todos.map((todo) => (
                <div key={todo.id}>
                    {todo.id}
                    {' '}
                    -
                    {todo.title}
                </div>
            ))}
            <div className={styles.pages}>
                {pages.map((p) => (
                    <div
                        className={cx(styles.page, { [styles.active]: p === page })}
                        key={p}
                        onClick={() => setTodoPage(p)}
                    >
                        {p}
                    </div>
                ))}
            </div>
        </div>
    );
};
